
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42 21c0 11.598-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0s21 9.402 21 21zm-11.02-5.118c1.015-.12 1.984-.39 2.883-.79a10.18 10.18 0 01-2.505 2.598c.01.215.015.432.015.65 0 6.633-5.05 14.282-14.282 14.282-2.835 0-5.474-.831-7.694-2.256.392.047.793.07 1.197.07 2.352 0 4.516-.802 6.234-2.148a5.025 5.025 0 01-4.689-3.486 5.025 5.025 0 002.267-.087 5.022 5.022 0 01-4.027-4.921v-.064a4.984 4.984 0 002.274.628 5.02 5.02 0 01-1.553-6.702 14.249 14.249 0 0010.346 5.246 5.02 5.02 0 014.889-6.164c1.445 0 2.75.61 3.665 1.585a10.049 10.049 0 003.188-1.218 5.033 5.033 0 01-2.208 2.777z","fill":"#F1F2F2"}})])
          )
        }
      }
    